import React from 'react'
import { Pill } from '../../../../ui'

const CYCLE = [null, 'minor', 'moderate', 'blocker']

// Custom 3-colour categorical palette: encodes severity intensity
// (minor / moderate / blocker). Could plausibly map to info/warn/danger
// but the palette diverges from the semantic Pill tones so the colours
// are passed via Pill's `style` override on top of the shared chip
// recipe. See docs/contributor/design-language.md §13.
const STYLES = {
  minor:    { background: '#E6F1FB', color: '#185FA5' },
  moderate: { background: '#FAC775', color: '#412402' },
  blocker:  { background: '#F7C1C1', color: '#501313' },
}

const PILL_OVERRIDE = {
  fontSize: 9,
  fontWeight: 500,
  padding: '2px 7px',
  maxWidth: 120,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}

export function SeverityChip({ value = null, onChange, disabled = false }) {
  const next = () => {
    const idx = CYCLE.indexOf(value)
    onChange(CYCLE[(idx + 1) % CYCLE.length])
  }

  if (value == null) {
    return (
      <Pill
        as="button"
        type="button"
        tone="neutral"
        onClick={() => !disabled && next()}
        disabled={disabled}
        aria-label="Add severity tag"
        style={{ ...PILL_OVERRIDE, background: 'transparent', color: 'var(--text-secondary)', opacity: 0.5 }}
      >
        + tag
      </Pill>
    )
  }

  return (
    <Pill
      as="button"
      type="button"
      tone="neutral"
      onClick={() => !disabled && next()}
      disabled={disabled}
      aria-label={`Severity: ${value}. Click to change.`}
      style={{ ...PILL_OVERRIDE, ...STYLES[value] }}
    >
      {value}
    </Pill>
  )
}
